// extracted by mini-css-extract-plugin
module.exports = {"image":"LazyImage-module-image--Gu_AJ"};